<template>
    <UserActivityTile @click="tileClicked()" :userActivity="userActivity">


        <template v-slot:title>{{ userActivity.body.offerName }}</template>
        <template v-slot:subtitle>{{ userActivity.username }} Started</template>


        <template v-slot:append-item-right>

            <UserActivityCoinChip>
                {{ $abbreviateNumber(userActivity.body.coinsAmount) }}
            </UserActivityCoinChip>

        </template>

    </UserActivityTile>
</template>



<script lang="ts" setup>

import { useRouter } from 'vue-router';
import { PropType } from 'vue';
import { IOfferStartedUserActivity } from '@/interfaces/UserActivity/IOfferStartedUserActivity';

import UserActivityTile from './UserActivityTile.vue';
import UserActivityCoinChip from '@/components/UserActivity/UserActivityTileElements/UserActivityCoinChip.vue';

const props = defineProps({
    userActivity: {
        type: Object as PropType<IOfferStartedUserActivity>,
        required: true,
    },
});

const router = useRouter();

const tileClicked = () => {
    router.push('/earn');
}

</script>
